(function () {
  function initScenarioShop(section) {
    if (!section || section.dataset.scenarioShopInit === 'true') return;
    section.dataset.scenarioShopInit = 'true';

    const tabs = section.querySelectorAll('[data-scenario-tab]');
    const panels = section.querySelectorAll('[data-scenario-panel]');
    const navbars = section.querySelector('.scenario-shop__navbars');
    const subacts = section.querySelector('[data-scenario-subacts]');
    const summaryBar = section.querySelector('[data-scenario-summary-bar]');
    const summaryScenarioBtn = section.querySelector('[data-scenario-summary-scenario-btn]');
    const summaryMomentBtn = section.querySelector('[data-scenario-summary-moment-btn]');
    const summaryScenarioEl = section.querySelector('[data-scenario-summary-scenario]');
    const summaryMomentEl = section.querySelector('[data-scenario-summary-moment]');
    const menu = section.querySelector('[data-scenario-menu]');
    const menuMoments = section.querySelector('[data-scenario-menu-moments]');
    const deepAnchor = section.dataset.deepAnchor || '#scenario-deep-products';
    if (!tabs.length || !panels.length) return;

    let activeScenario = '';
    let selectedMomentId = null;
    let menuOpen = false;
    let menuFocus = 'moment';

    function getHeaderOffset() {
      const root = document.documentElement;
      const live = getComputedStyle(root).getPropertyValue('--header-height-live').trim();
      const base = getComputedStyle(root).getPropertyValue('--header-height').trim();
      const value = parseFloat(live || base || '0');
      return Number.isFinite(value) ? value : 0;
    }

    function isMobileNav() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function setSummaryExpanded(expanded) {
      var value = expanded ? 'true' : 'false';
      if (summaryBar) summaryBar.classList.toggle('is-open', expanded);
      if (summaryMomentBtn) summaryMomentBtn.setAttribute('aria-expanded', value);
    }

    function focusMenuGroup(focus) {
      if (!menu) return;
      var target =
        focus === 'scenario'
          ? menu.querySelector('[data-scenario-menu-tab]')
          : menu.querySelector('[data-scenario-menu-moments]');
      if (!target) return;
      var group = target.closest('.scenario-shop__menu-group') || target;
      try {
        group.scrollIntoView({ block: 'nearest' });
      } catch (e) {}
    }

    function closeMenu() {
      if (!menu) return;
      menu.hidden = true;
      menuOpen = false;
      document.documentElement.classList.remove('scenario-shop-menu-open');
      setSummaryExpanded(false);
    }

    function openMenu(focus) {
      if (!menu || !isMobileNav()) return;
      menuFocus = focus === 'scenario' ? 'scenario' : 'moment';
      syncMenuUi(activeScenario);
      menu.hidden = false;
      menuOpen = true;
      document.documentElement.classList.add('scenario-shop-menu-open');
      setSummaryExpanded(true);
      focusMenuGroup(menuFocus);
    }

    function toggleMenu(focus) {
      if (menuOpen && menuFocus === focus) closeMenu();
      else openMenu(focus);
    }

    function goToBigScenarioView() {
      closeMenu();
      if (!activeScenario) return;
      var panel = section.querySelector('[data-scenario-panel="' + activeScenario + '"]');
      activateMoment(panel, 'default', { scroll: false });
      if (navbars) {
        window.scrollTo({
          top: navbars.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - 1,
          behavior: 'smooth'
        });
      }
    }

    function syncMenuUi(scenarioKey) {
      if (!menu) return;
      menu.querySelectorAll('[data-scenario-menu-tab]').forEach(function (btn) {
        var on = btn.getAttribute('data-scenario-menu-tab') === scenarioKey;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (!menuMoments) return;
      menuMoments.querySelectorAll('[data-scenario-menu-moment]').forEach(function (btn) {
        var match = btn.getAttribute('data-moment-scenario') === scenarioKey;
        btn.hidden = !match;
        var isActive =
          match &&
          !!selectedMomentId &&
          btn.getAttribute('data-scenario-menu-moment') === selectedMomentId;
        btn.classList.toggle('is-active', !!isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function updateSummary() {
      if (!summaryBar) return;
      var tab = section.querySelector('[data-scenario-tab].is-active');
      var scenarioLabel =
        (tab && (tab.getAttribute('data-tab-label') || '').trim()) ||
        (tab ? tab.textContent.trim().split('\n')[0].trim() : '') ||
        '';
      var momentLabel = '';
      var momentSelected = false;
      if (subacts && activeScenario && selectedMomentId) {
        var momentBtn = subacts.querySelector(
          '[data-scenario-moment="' + selectedMomentId + '"]'
        );
        if (momentBtn) {
          momentLabel = momentBtn.textContent.trim();
          momentSelected = true;
        }
      }
      if (!momentSelected) {
        momentLabel =
          (summaryBar.getAttribute('data-moment-placeholder') || '').trim() ||
          'Choose activity';
      }
      if (summaryScenarioEl) summaryScenarioEl.textContent = scenarioLabel;
      if (summaryMomentEl) summaryMomentEl.textContent = momentLabel;
      if (summaryMomentBtn) {
        summaryMomentBtn.classList.toggle('is-placeholder', !momentSelected);
      }
      if (isMobileNav()) {
        summaryBar.hidden = !scenarioLabel;
      } else {
        summaryBar.hidden = true;
        closeMenu();
      }
      syncMenuUi(activeScenario);
    }

    function initStickyNav() {
      if (!navbars || navbars.dataset.stickyInit === 'true') return;
      navbars.dataset.stickyInit = 'true';

      var spacer = section.querySelector('.scenario-shop__tabs-spacer');
      if (!spacer) {
        spacer = document.createElement('div');
        spacer.className = 'scenario-shop__tabs-spacer';
        spacer.setAttribute('aria-hidden', 'true');
        navbars.parentNode.insertBefore(spacer, navbars.nextSibling);
      }

      function measureAndStick(shouldStick) {
        if (shouldStick) {
          navbars.classList.add('is-stuck', 'is-compact');
          // Remeasure after compact styles apply
          spacer.style.height = navbars.offsetHeight + 'px';
          spacer.classList.add('is-active');
        } else {
          navbars.classList.remove('is-stuck', 'is-compact');
          spacer.style.height = '';
          spacer.classList.remove('is-active');
        }
      }

      function syncStuckState() {
        var headerOffset = getHeaderOffset();
        var referenceTop = spacer.classList.contains('is-active')
          ? spacer.getBoundingClientRect().top
          : navbars.getBoundingClientRect().top;
        var shouldStick = referenceTop <= headerOffset + 0.5;
        measureAndStick(shouldStick);
      }

      window.addEventListener(
        'scroll',
        function () {
          syncStuckState();
        },
        { passive: true }
      );
      window.addEventListener('resize', function () {
        if (!isMobileNav()) closeMenu();
        syncStuckState();
        updateSummary();
      });
      syncStuckState();
    }

    initStickyNav();

    function getParams() {
      try {
        return new URLSearchParams(window.location.search);
      } catch (e) {
        return new URLSearchParams();
      }
    }

    function isMobileViewport() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function pauseVideos(root) {
      if (!root) return;
      root.querySelectorAll('video').forEach(function (video) {
        try {
          video.pause();
        } catch (e) {}
      });
    }

    function playVideo(video) {
      if (!video) return;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    /* Play only the viewport layer (desktop/mobile); pause the other. */
    function syncShopMedia(mediaRoot) {
      if (!mediaRoot) return;
      var mobile = isMobileViewport();
      var desktopLayer = mediaRoot.querySelector('[data-shop-media="desktop"]');
      var mobileLayer = mediaRoot.querySelector('[data-shop-media="mobile"]');
      var activeLayer = mobile ? mobileLayer : desktopLayer;
      var idleLayer = mobile ? desktopLayer : mobileLayer;

      pauseVideos(mediaRoot);

      if (idleLayer) {
        idleLayer.querySelectorAll('video').forEach(function (video) {
          try {
            video.removeAttribute('autoplay');
            video.preload = 'none';
          } catch (e) {}
        });
      }

      if (activeLayer) {
        var video = activeLayer.querySelector('video');
        if (video) {
          try {
            video.muted = true;
            video.playsInline = true;
            video.setAttribute('playsinline', '');
            video.preload = mobile ? 'metadata' : 'auto';
          } catch (e) {}
          playVideo(video);
        }
      }
    }

    function playVideos(root) {
      syncShopMedia(root);
    }

    function syncActiveShopMedia() {
      var panel =
        section.querySelector('[data-scenario-panel].is-active') ||
        section.querySelector('[data-scenario-panel]:not([hidden])');
      if (!panel) return;
      var media =
        panel.querySelector('[data-scenario-media].is-active') ||
        panel.querySelector('[data-scenario-media="default"]');
      if (media) syncShopMedia(media);
    }

    function setText(el, value) {
      if (!el) return;
      el.textContent = value || '';
      el.hidden = !value;
    }

    function firstMomentKey(scenarioKey) {
      var tab = section.querySelector('[data-scenario-tab="' + scenarioKey + '"]');
      return tab ? (tab.dataset.firstMoment || '').trim() : '';
    }

    function syncSubacts(scenarioKey) {
      if (!subacts) return;
      subacts.querySelectorAll('[data-scenario-moment]').forEach(function (btn) {
        var match = btn.dataset.momentScenario === scenarioKey;
        btn.hidden = !match;
        if (!match) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-pressed', 'false');
        }
      });
    }

    function writeUrl(scenarioKey, momentKey, selected) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('scenario', scenarioKey);
        if (selected && momentKey) url.searchParams.set('moment', momentKey);
        else url.searchParams.delete('moment');
        window.history.replaceState(
          { scenario: scenarioKey, moment: momentKey || null },
          '',
          url.toString()
        );
      } catch (e) {}
    }

    function emitMoment(scenarioKey, momentKey, selected) {
      var effective = selected && momentKey ? momentKey : firstMomentKey(scenarioKey);
      section.dispatchEvent(
        new CustomEvent('scenario:moment-change', {
          bubbles: true,
          detail: {
            scenario: scenarioKey,
            moment: selected ? momentKey : '',
            effectiveMoment: effective,
            selected: !!selected
          }
        })
      );
    }

    function queryDeepTarget(selector) {
      if (!selector) return null;
      try {
        return document.querySelector(selector);
      } catch (e) {
        return null;
      }
    }

    function scrollToDeep() {
      var el = null;
      document.querySelectorAll('[data-scenario-deep-products]').forEach(function (node) {
        var root = node.closest('[data-scenario-deep]');
        if (root && !root.hidden && !node.hidden) el = node;
      });
      if (!el) el = queryDeepTarget(deepAnchor);
      if (!el) el = document.querySelector('[data-scenario-deep-products]');
      if (!el) return;
      window.scrollTo({
        top: el.getBoundingClientRect().top + window.scrollY - 110,
        behavior: 'smooth'
      });
    }

    function trackSlug(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    // Banner1 = Intro；Shop 大场景 = Banner2；Shop 小场景 = scenario-banner-{moment}（不加 1/2）
    function clearBannerTrackClasses(el) {
      if (!el) return;
      Array.prototype.slice.call(el.classList).forEach(function (cls) {
        if (
          cls.indexOf('scenario-banner1-') === 0 ||
          cls.indexOf('scenario-banner2-') === 0 ||
          cls.indexOf('scenario-banner-') === 0
        ) {
          el.classList.remove(cls);
        }
      });
    }

    function syncShopBannerTrack(panel, scenarioKey, momentKey, selected) {
      if (!panel) return;

      // Shop CTA：大场景 scenario-banner2-{scenario}；小场景 scenario-banner-{moment}（无序号）
      var shopCta = panel.querySelector('[data-scenario-banner2-cta]');
      if (shopCta) {
        clearBannerTrackClasses(shopCta);
        if (selected && momentKey) {
          var momentSlug = trackSlug(momentKey);
          if (momentSlug) shopCta.classList.add('scenario-banner-' + momentSlug);
        } else {
          var scenarioSlug = trackSlug(scenarioKey);
          if (scenarioSlug) shopCta.classList.add('scenario-banner2-' + scenarioSlug);
        }
      }

      // Intro Explore：始终 scenario-banner1-{大场景}
      document.querySelectorAll('[data-scenario-intro] [data-scenario-banner1-cta]').forEach(function (introCta) {
        clearBannerTrackClasses(introCta);
        var introSlug = trackSlug(scenarioKey);
        if (introSlug) introCta.classList.add('scenario-banner1-' + introSlug);
      });
    }

    function activateMoment(panel, momentId, options) {
      if (!panel) return;
      var opts = options || {};
      if (
        (!momentId || momentId === 'default') &&
        !panel.querySelector('[data-scenario-media="default"]')
      ) {
        var firstMedia = panel.querySelector('[data-scenario-media]');
        if (firstMedia) momentId = firstMedia.getAttribute('data-scenario-media');
      }
      var medias = panel.querySelectorAll('[data-scenario-media]');
      var tagEl = panel.querySelector('[data-scenario-tag]');
      var headingEl = panel.querySelector('[data-scenario-heading]');
      var leadEl = panel.querySelector('[data-scenario-lead]');
      var scenarioKey = panel.dataset.scenarioPanel;
      var activeMedia = null;
      var selected = !!(momentId && momentId !== 'default');

      medias.forEach(function (media) {
        var isActive = media.dataset.scenarioMedia === (selected ? momentId : 'default');
        media.classList.toggle('is-active', isActive);
        media.hidden = !isActive;
        if (isActive) {
          activeMedia = media;
          playVideos(media);
        } else {
          pauseVideos(media);
        }
      });

      if (!activeMedia) {
        var fallback = panel.querySelector('[data-scenario-media="default"]');
        if (fallback) {
          fallback.classList.add('is-active');
          fallback.hidden = false;
          playVideos(fallback);
        }
      }

      panel.classList.toggle('is-small', selected);

      if (subacts) {
        subacts.querySelectorAll('[data-scenario-moment]').forEach(function (btn) {
          var isActive = selected && btn.dataset.scenarioMoment === momentId;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      if (selected) {
        var btn = subacts
          ? subacts.querySelector('[data-scenario-moment="' + momentId + '"]')
          : null;
        setText(headingEl, (btn && btn.dataset.momentHeading) || panel.dataset.defaultHeading);
        setText(leadEl, (btn && btn.dataset.momentLead) || panel.dataset.defaultLead);
        setText(tagEl, panel.dataset.defaultTag);
        selectedMomentId = momentId;
      } else {
        setText(tagEl, panel.dataset.defaultTag);
        setText(headingEl, panel.dataset.defaultHeading);
        setText(leadEl, panel.dataset.defaultLead);
        selectedMomentId = null;
      }

      var activeBtn = selected
        ? subacts && subacts.querySelector('[data-scenario-moment="' + momentId + '"]')
        : null;
      var momentKey = activeBtn
        ? (activeBtn.getAttribute('data-moment-key') || activeBtn.dataset.momentKey || '').trim()
        : '';

      writeUrl(scenarioKey, momentKey, selected);
      emitMoment(scenarioKey, momentKey, selected);
      updateSummary();
      syncShopBannerTrack(panel, scenarioKey, momentKey, selected);

      if (selected && opts.scroll !== false) {
        // Jump to Scenario shop hero (2nd video). Use section, not sticky navbars —
        // sticky getBoundingClientRect stays in-viewport and would not scroll from FAQ etc.
        window.scrollTo({
          top: section.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - 1,
          behavior: 'smooth'
        });
      }
    }

    function activateScenario(key, options) {
      var opts = options || {};
      activeScenario = key;

      tabs.forEach(function (tab) {
        var isActive = tab.dataset.scenarioTab === key;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.dataset.scenarioPanel === key;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
        if (!isActive) {
          pauseVideos(panel);
        }
      });

      syncSubacts(key);

      var panel = section.querySelector('[data-scenario-panel="' + key + '"]');
      var requestedMoment = (opts.momentKey || '').trim();
      var momentBtn = null;
      if (requestedMoment && subacts) {
        momentBtn = Array.from(subacts.querySelectorAll('[data-scenario-moment]')).find(
          function (btn) {
            return (
              btn.dataset.momentScenario === key &&
              (btn.getAttribute('data-moment-key') || btn.dataset.momentKey) === requestedMoment
            );
          }
        );
      }

      section.dispatchEvent(
        new CustomEvent('scenario:change', {
          bubbles: true,
          detail: {
            scenario: key,
            defaultMoment: firstMomentKey(key),
            effectiveMoment: momentBtn ? requestedMoment : firstMomentKey(key)
          }
        })
      );

      if (momentBtn) {
        activateMoment(panel, momentBtn.dataset.scenarioMoment, { scroll: !!opts.scroll });
      } else {
        activateMoment(panel, 'default', { scroll: false });
      }

      updateSummary();

      if (opts.scrollNav && navbars) {
        window.scrollTo({
          top: navbars.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - 1,
          behavior: 'smooth'
        });
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateScenario(tab.dataset.scenarioTab, { scrollNav: true });
      });
    });

    // Only the small-scenario control may open the dropdown.
    // Big-scenario control returns to default hero and must never open the menu.
    // Use capture + stopImmediatePropagation so parent/legacy listeners cannot open it.
    if (summaryBar) {
      summaryBar.addEventListener(
        'click',
        function (event) {
          var scenarioHit = event.target.closest('[data-scenario-summary-scenario-btn]');
          var momentHit = event.target.closest('[data-scenario-summary-moment-btn]');

          if (scenarioHit) {
            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') {
              event.stopImmediatePropagation();
            }
            goToBigScenarioView();
            return;
          }

          if (momentHit) {
            event.preventDefault();
            event.stopPropagation();
            toggleMenu('moment');
          }
        },
        true
      );
    }

    if (menu) {
      menu.addEventListener('click', function (event) {
        if (event.target.closest('[data-scenario-menu-close]')) {
          event.preventDefault();
          closeMenu();
          return;
        }

        var menuTab = event.target.closest('[data-scenario-menu-tab]');
        if (menuTab) {
          event.preventDefault();
          activateScenario(menuTab.getAttribute('data-scenario-menu-tab'), {
            scroll: false,
            scrollNav: false
          });
          syncMenuUi(activeScenario);
          return;
        }

        var menuMoment = event.target.closest('[data-scenario-menu-moment]');
        if (menuMoment && !menuMoment.hidden) {
          event.preventDefault();
          var scenarioKey = menuMoment.getAttribute('data-moment-scenario');
          var momentId = menuMoment.getAttribute('data-scenario-menu-moment');
          var panel = section.querySelector('[data-scenario-panel="' + scenarioKey + '"]');
          if (scenarioKey !== activeScenario) {
            activateScenario(scenarioKey, { scroll: false, scrollNav: false });
          }
          if (selectedMomentId !== momentId) {
            activateMoment(panel, momentId, { scroll: true });
          }
          closeMenu();
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menuOpen) closeMenu();
    });

    section.addEventListener('click', function (event) {
      var momentBtn = event.target.closest('[data-scenario-moment]');
      if (momentBtn && subacts && subacts.contains(momentBtn)) {
        event.preventDefault();
        var scenarioKey = momentBtn.dataset.momentScenario;
        var panel = section.querySelector('[data-scenario-panel="' + scenarioKey + '"]');
        if (!momentBtn.classList.contains('is-active')) {
          activateMoment(panel, momentBtn.dataset.scenarioMoment, { scroll: true });
        }
        return;
      }

      var deepScrollBtn = event.target.closest('[data-scenario-deep-scroll]');
      if (deepScrollBtn) {
        var deepHref = (deepScrollBtn.getAttribute('href') || '').trim();
        // Hash / attribute anchors → smooth scroll to visible deep products.
        // Absolute URLs keep normal navigation.
        if (
          !deepHref ||
          deepHref.charAt(0) === '#' ||
          deepHref.charAt(0) === '[' ||
          deepHref === deepAnchor
        ) {
          event.preventDefault();
          scrollToDeep();
          return;
        }
      }

      var selectorBtn = event.target.closest('[data-scenario-selector-open]');
      if (!selectorBtn) return;
      event.preventDefault();
      document.dispatchEvent(
        new CustomEvent('scenario:open-selector', {
          bubbles: true,
          detail: {
            scenario: activeScenario || tabs[0].dataset.scenarioTab,
            source: 'hero'
          }
        })
      );
    });

    var params = getParams();
    var urlScenario = params.get('scenario');
    var urlMoment = params.get('moment');
    var validKeys = Array.from(tabs).map(function (tab) {
      return tab.dataset.scenarioTab;
    });
    var initial = urlScenario && validKeys.indexOf(urlScenario) !== -1 ? urlScenario : validKeys[0];
    activateScenario(initial, { momentKey: urlMoment || '', scroll: false });

    if (!section._scenarioShopMediaMq) {
      section._scenarioShopMediaMq = window.matchMedia('(max-width: 749px)');
      var onShopMediaMq = function () {
        syncActiveShopMedia();
      };
      if (typeof section._scenarioShopMediaMq.addEventListener === 'function') {
        section._scenarioShopMediaMq.addEventListener('change', onShopMediaMq);
      } else if (typeof section._scenarioShopMediaMq.addListener === 'function') {
        section._scenarioShopMediaMq.addListener(onShopMediaMq);
      }
    }

    section._scenarioActivate = activateScenario;
  }

  function initAll() {
    document.querySelectorAll('[data-scenario-shop]').forEach(initScenarioShop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section =
      event.target.querySelector('[data-scenario-shop]') ||
      event.target.closest('[data-scenario-shop]');
    if (section) {
      section.dataset.scenarioShopInit = 'false';
      var nav = section.querySelector('.scenario-shop__navbars');
      if (nav) nav.dataset.stickyInit = 'false';
      initScenarioShop(section);
    }
  });

  document.addEventListener('scenario:activate', function (event) {
    var key = event.detail && event.detail.scenario;
    var momentKey = (event.detail && event.detail.moment) || '';
    if (!key) return;
    document.querySelectorAll('[data-scenario-shop]').forEach(function (section) {
      var tab = section.querySelector('[data-scenario-tab="' + key + '"]');
      if (!tab) return;
      if (section._scenarioActivate) {
        section._scenarioActivate(key, { momentKey: momentKey, scrollNav: true });
        return;
      }
      tab.click();
      if (momentKey) {
        var btn = section.querySelector(
          '[data-scenario-moment][data-moment-key="' + momentKey + '"]'
        );
        if (btn) btn.click();
      }
    });
  });
})();
